var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#0dc9f7",
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.904 15.739l-3.045 2.364-1.247-4.325-7.224-1.935 9.481.487z",
    fillOpacity: 0.305
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27 23.993L24.586 11.33 26 14.476l-1.855-.513-.065 3.264z",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.796 17.78l-4.747-8.161L6 9l9.183 2.461 2.49 8.49z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWings);
export default __webpack_public_path__ + "static/media/wings.a66b697a7e05d3defad4e326d552090d.svg";
export { ForwardRef as ReactComponent };